import Home from './views/Home';
export const App = (): JSX.Element => {
  return <Home />;
};

export default App;
